/**
 * Quiz results VSL reserve CTA: clear cart, add one variant, go to checkout.
 * Listens for clicks on .product-add-to-cart[data-variant-id].
 */
(function () {
  var OVERLAY_ID = 'quiz-results-vsl-cart-overlay';

  function showCartLoadingOverlay() {
    if (document.getElementById(OVERLAY_ID)) return;
    var el = document.createElement('div');
    el.id = OVERLAY_ID;
    el.className = 'quiz-results-vsl-cart-overlay';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-busy', 'true');
    el.innerHTML =
      '<div class="quiz-results-vsl-cart-overlay__inner">Adding to Cart...</div>';
    document.body.appendChild(el);
    document.body.style.overflow = 'hidden';
  }

  function hideCartLoadingOverlay() {
    var el = document.getElementById(OVERLAY_ID);
    if (el) {
      el.parentNode.removeChild(el);
    }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-add-to-cart[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    var raw = btn.getAttribute('data-variant-id');
    var variantId = parseInt(raw, 10);
    if (!variantId || Number.isNaN(variantId)) return;

    if (btn.dataset.loading === 'true') return;
    btn.dataset.loading = 'true';
    var prevText = btn.textContent;
    btn.disabled = true;

    showCartLoadingOverlay();

    function fail() {
      hideCartLoadingOverlay();
      btn.disabled = false;
      btn.dataset.loading = 'false';
      btn.textContent = prevText;
      window.alert('Unable to update your cart. Please try again.');
    }

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('clear');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = '/checkout';
      })
      .catch(fail);
  });
})();
